export default __webpack_public_path__ + "static/media/nav-arrow.0524d5ca.svg";